import styled from "styled-components";
import { media } from "../../theme/theme";

export const ScrollDownArrowContainer = styled.div`
    position: relative;
`;

export const ScrollDownArrowWrapper = styled.div<{ notificationBarOn?: boolean, hideOnMobile?: boolean }>`
    position: absolute;
    min-height: 100%;
    height:  ${({ notificationBarOn }) => notificationBarOn ? "calc(100vh - 190px)" : "calc(100vh - 150px)"};
    max-height: calc(100% + 100px);
    width: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    display: none;

    ${media.tablet} {
        display: block;
    }
`;

export const ScrollDownSVG = styled.svg`
    position: absolute;
    bottom: 100px;
    left: 50%;
    animation-delay: 0;
    animation-iteration-count: infinite;
    animation-duration: 4000ms;
    animation-name: bounceInDown;
    animation-fill-mode: ease;
    opacity: 1;

    @keyframes bounceInDown {

        0% {
            transform: translate3d(-50%, 60px, 0) scaleY(1);
        }

        70% {
            transform: translate3d(-50%, 60px, 0) scaleY(1);
        }

        85% {
            transform: translate3d(-50%, 70px, 0) scaleY(1.1);
        }

        to {
            transform: translate3d(-50%, 60px, 0) scaleY(1);
        }
    }

`;


